<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <div class="header-section">
          <!-- Document Name Showcase -->
          <div class="document-showcase">
            <div class="document-header">
              <div class="document-info">
                <h2 class="document-name">
                  {{ documentName || "No Document Selected" }}
                </h2>
              </div>

              <div class="toggle-section">
              <v-switch
                v-model="CheckboxShowAllText"
                color="primary"
                hide-details
                density="compact"
                inset
                class="compact-toggle"
              >
                <template #label>
                  <div class="toggle-label">
                    <span style="font-size: 1rem">{{
                      $t("_ShowAllText")
                    }}</span>
                  </div>
                </template>
              </v-switch>
            </div>

            <v-btn
              id="button-add-uploadsoundtodocumentdetail"
              color="success"
              variant="flat"
              @click="Add()"
              class="create-btn custombtn"
            >
              <v-icon start size="18">mdi-plus</v-icon>
              {{ $t("add") }}
            </v-btn>
            </div>
          </div>
        </div>
        <v-flex class="flex">
          <v-data-table-server
            v-model:options="options"
            :items-per-page="options.itemsPerPage"
            :loading="loading"
            :items-length="speechDocumentDataDetail.total"
            :items="speechDocumentDataDetail.data"
            :headers="headers"
            class="px-5"
          >
            <template v-slot:item="{ item }">
              <tr class="table-row">
                <td class="number-cell">
                  {{ item.number }}
                </td>

                <td class="text-cell">
                  <div class="text-container">
                    <div class="text-content-wrapper">
                      <span
                        :class="[
                          item.show ? 'text-content-show' : 'text-content',
                        ]"
                        v-html="formatText(item.originalText)"
                      ></span>
                    </div>
                  </div>
                </td>

                <td class="text-cell">
                  <div class="text-container">
                    <div class="text-content-wrapper">
                      <span
                        :class="[
                          item.show ? 'text-content-show' : 'text-content',
                        ]"
                        v-html="formatText(item.summarizedText)"
                        :style="getStyle(item.summarizedText)"
                      ></span>
                    </div>
                    <v-btn
                      icon
                      variant="text"
                      size="small"
                      color="#C32E0E"
                      @click="item.show = !item.show"
                      class="expand-btn"
                    >
                      <v-icon
                        size="20"
                        color="#C32E0E"
                        :color="item.show ? 'primary' : 'grey'"
                      >
                        {{ item.show ? "mdi-chevron-up" : "mdi-chevron-down" }}
                      </v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ item.show ? "Collapse" : "Expand" }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>

                <td class="action-cell">
                  <div class="action-container">
                    <div class="action-group">
                      <!-- Import Button -->
                      <v-btn id="button-importdocument-popupimportdocument-uploadsoundtodocumentdetail" variant="text" density="comfortable"
                        @click="ImportDocument(item)" class="importbtn">
                        <v-img :src="images.importImg" alt="Import" style="width: 20px; height: 20px;" />
                        Import
                        <v-tooltip activator="parent" location="top">
                        Import to Knowledge Base
                      </v-tooltip>
                      </v-btn>
                      <!-- Edit Button -->
                      <v-btn
                        id="button-edit-popupedit-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="EditSpeechDocumentDetail(item)"
                        class="action-btn edit-btn"
                        icon
                        size="small"
                      >
                        <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                        <v-tooltip activator="parent" location="top"
                          >Edit</v-tooltip
                        >
                      </v-btn>
                      <!-- Summarize Button -->
                      <v-btn
                        id="button-summarized-popupsummarized-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="SummarizedPopup(item)"
                        class="action-btn summarize-btn"
                        icon
                        size="small"
                      >
                        <v-icon size="18">mdi-auto-fix</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Summarize with AI Model
                        </v-tooltip>
                      </v-btn>
                      <!-- Delete Button -->
                      <v-btn
                        id="button-delete-uploadsoundtodocumentdetail"
                        variant="text"
                        density="comfortable"
                        @click="DeleteById(item.id)"
                        class="action-btn delete-btn"
                        icon
                        size="small"
                      >
                        <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                        <v-tooltip activator="parent" location="top"
                          >Delete</v-tooltip
                        >
                      </v-btn>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:bottom>
              <v-card-actions class="justify-end pa-4">
                <v-btn
                  id="button-close-uploadsoundtodocumentdetail"
                  variant="text"
                  color="#C32E0E"
                  class="close-all-btn"
                  to="/UploadSoundToDocument"
                >
                  Close All
                </v-btn>
              </v-card-actions>
            <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
              <div>Total results {{ speechDocumentDataDetail.total }}</div>

              <v-data-table-footer :items-per-page-options="[10, 20, 50]" v-model:items-per-page="itemsPerPage"
                :page="options.page" :length="Math.ceil(speechDocumentDataDetail.total / itemsPerPage)" />
            </div>
          </template>
          </v-data-table-server>
        </v-flex>
      </v-card>
    </v-container>

    <!--Upload popup-->
    <v-container fluid>
      <v-dialog
        v-model="uploadDialog"
        max-width="900px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">Upload Speech Files</h2>
                <p class="dialog-subtitle">
                  Upload and process audio files for transcription
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="uploadDialog = false"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <!-- Document Name and Language Row -->
            <v-row>
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">Transcription Name <span style="color: red">*</span></label>
                  <v-text-field
                    v-model="documentName"
                    :rules="[rules.required]"
                    required
                    variant="outlined"
                    disabled
                    hide-details="auto"
                    class="modern-input"
                    color="primary"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label">Language <span style="color: red">*</span></label>
                  <v-select
                    id="language-autocomplete-uploadsoundtodocumentdetail"
                    :items="langaugeType"
                    item-title="name"
                    item-value="value"
                    v-model="request.langPop"
                    variant="outlined"
                    hide-details
                    class="modern-input"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'language-uploadsoundtodocumentdetail-option-' + index" 
                        :value="item.raw.name"
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template #prepend-inner>
                      <v-img :src="images.langImg" alt="Language" style="width: 20px; height: 20px;" />
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <!-- AI Model and Bot Summation Row -->
            <v-row class="mb-2">
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-switch
                  id="botsummation-checkbox-uploadsoundtodocumentdetail"
                  v-model="botSummation"
                  color="primary"
                  hide-details
                  density="compact"
                  inset
                  class="inline-switch mt-4"
                  :class="[
                        'publication-toggle',
                        botSummation
                          ? 'publication-toggle--active'
                          : 'publication-toggle--inactive',
                        botSummation ? 'inline-switch-active': 'inline-switch',
                      ]"
                >
                  <template #label>
                    <div class="inline-label">
                      <span class="mr-2">AI Summarization</span>
                    </div>
                  </template>
                </v-switch>
              </v-col>
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">AI Model for Summarization <span style="color: red">*</span></label>
                  <v-select
                    :items="listDDModelDisplayName"
                    :item-title="getItemModelNameText"
                    :item-value="getItemModelNameID"
                    :disabled="!botSummation"
                    v-model="modelDisplayID"
                    variant="outlined"
                    clearable
                    hide-details
                    placeholder="Select AI model for text summation"
                    class="modern-input"
                    :class="{ 'input-disabled': !botSummation }"
                    :rules="[v => !!v || 'Required.']"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'aimodel-uploadsoundtodocumentdetail-option-' + index" 
                        :value="item.raw.name"
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <!-- <template #prepend-inner>
                      <v-icon color="primary" size="20"
                        >mdi-robot-outline</v-icon
                      >
                    </template> -->
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <!-- File Upload Area -->
            <div class="upload-section">
              <v-card
                variant="outlined"
                class="upload-area-card"
                :class="{ 'drag-over': isDragOver }"
              >
                <MultipleDragAndDrop
                  :dialog.sync="uploadDialog"
                  :multiple="true"
                  @filesUploaded="processUpload($event)"
                  @dragover="isDragOver = true"
                  @dragleave="isDragOver = false"
                  @drop="isDragOver = false"
                />
              </v-card>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left">
              </div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="uploadDialog = false"
                  class="dialog-action-btn cancel-btn"
                >
                  Cancel
                </v-btn>

                <v-btn
                  id="button-save-popupupload-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="Save()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-add"
                  :disabled="!documentName || !request.filesList"
                >
                  <v-img :src="images.uploadImg" alt="Upload" style="width: 20px; height: 20px;" class="mr-2" />
                  Upload Files
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Edit popup-->
    <v-container fluid>
      <v-dialog
        v-model="editDialog"
        max-width="900px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">Edit Text Summary</h2>
                <p class="dialog-subtitle">
                  Review and edit both the original and summarized text
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="editDialog = false"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row>
              <v-col cols="12" md="6">
                <div class="input-group">
                  <label class="input-label">Original Text <span style="color: red">*</span></label>
                  <v-textarea
                    v-model="edit.originalText"
                    id="originaltext-textarea-edit-uploadsoundtodocumentdetail"
                    variant="outlined"
                    rows="8"
                    hide-details="auto"
                    class="modern-input"
                  >
                  </v-textarea>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="input-group">
                  <label class="input-label">Summarized Text</label>
                  <v-textarea
                    v-model="edit.summarizedText"
                    id="summarizedtext-textarea-edit-uploadsoundtodocumentdetail"
                    variant="outlined"
                    rows="8"
                    hide-details="auto"
                    class="modern-input"
                  >
                  
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="editDialog = false"
                  class="dialog-action-btn cancel-btn"
                >
                  Cancel
                </v-btn>

                <v-btn
                  id="button-editsave-popupedit-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="EditSave()"
                  class="dialog-action-btn save-btn-edit"
                >
                  <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
                  Save Changes
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!--Import popup-->
    <v-container fluid>
      <v-dialog
        v-model="importDocPopup"
        max-width="700px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">Import To Knowledge Document</h2>
                <p class="dialog-subtitle">
                  Add the processed text to your knowledge base
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="importDocPopup = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row class="mb-4">
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">Choose an existing document <span style="color: red">*</span></label>
                  <v-select
                    id="docname-autocomplete-popupimport-uploadsoundtodocumentdetail"
                    :items="listDDLVector"
                    :item-title="getDocName"
                    :item-value="getDocId"
                    v-model="DocId"
                    :rules="[rules.required]"
                    variant="outlined"
                    clearable
                    hide-details="auto"
                    placeholder="Choose a knowledge document"
                    class="modern-input"
                    color="primary"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item 
                        v-bind="props"
                        :id="'docname-uploadsoundtodocumentdetail-option-' + index" 
                        :value="item.raw.name"
                      >
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <!-- <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-database</v-icon>
                    </template> -->
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label">Max Character/Chunk <span style="color: red">*</span></label>
                  <v-text-field
                    v-model="maxLimitedCharacter"
                    placeholder="5000"
                    :rules="[rules.required]"
                    variant="outlined"
                    hide-details="auto"
                    class="modern-input number-input-custom"
                    color="#3859D0"
                  >
                    <template #prepend-inner>
                      <v-icon color="#3859D0" size="20" style="opacity: 1;">mdi-format-text</v-icon>
                    </template>
                    
                    <template #append-inner>
                      <div class="number-controls-wrapper">
                        <!-- Clear button -->
                        <v-btn
                          v-if="maxLimitedCharacter"
                          icon
                          variant="text"
                          size="small"
                          class="clear-btn-custom"
                          @click="clearValue"
                        >
                          <v-icon size="16" color="white">mdi-close</v-icon>
                        </v-btn>
                        <!-- Up/Down arrows with custom color -->
                        <div class="number-arrows">
                          <v-btn
                            icon
                            variant="text"
                            size="x-small"
                            class="number-arrow-btn arrow-up"
                            @click="incrementValue"
                          >
                            <v-icon size="25" color="#3859D0">mdi-menu-up</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            variant="text"
                            size="x-small"
                            class="number-arrow-btn arrow-down"
                            @click="decrementValue"
                          >
                            <v-icon size="25" color="#3859D0">mdi-menu-down</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <div class="info-card">
              <v-icon class="mr-2">mdi-information-outline</v-icon>
              <div>
                This step will import the processed text, whether it’s the original or transcribed content, 
into the selected document.
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="importDocPopup = false"
                  class="dialog-action-btn cancel-btn"
                >
                  Cancel
                </v-btn>
                <v-btn
                  id="button-upload-popupimport-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="SaveImport"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!DocId || !maxLimitedCharacter"
                >
                  <v-img :src="images.importrightImg" width="20" height="20" class="mr-2"></v-img>
                  Import
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!--Summarized popup-->
    <v-container fluid>
      <v-dialog
        v-model="SummarizedPreparePopup"
        max-width="600px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-text">
                <h2 class="dialog-title">Summarize This Text</h2>
                <p class="dialog-subtitle">Generate an AI-powered summary for this chunk of text</p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                @click="SummarizedPreparePopup = false"
                class="close-button"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <div class="input-group">
              <label >AI Model for Summarization <span style="color: red">*</span></label>
              <v-select
                id="summarizedtext-autocomplete-uploadsoundtodocumentdetail"
                :items="listDDModelDisplayName"
                :item-title="getItemModelNameText"
                :item-value="getItemModelNameID"
                :rules="[rules.required]"
                v-model="SummarizedRow.modelDisplayID"
                variant="outlined"
                clearable
                hide-details="auto"
                placeholder="Select an AI model to summarize the transcribed content"
                class="modern-input"
                color="primary"
              >
                <template v-slot:item="{ props, item, index }">
                  <v-list-item 
                    v-bind="props"
                    :id="'summarizedtext-uploadsoundtodocumentdetail-option-' + index" 
                    :value="item.raw.name"
                  >
                    <template v-slot:title>
                      <span>{{ item.raw.name }}</span>
                    </template>
                  </v-list-item>
                </template>
                <!-- <template #prepend-inner>
                  <v-icon color="primary" size="20">mdi-robot-outline</v-icon>
                </template> -->
              </v-select>
            </div>

            <div class="info-card mt-4">
              <v-icon class="mr-2">mdi-information-outline</v-icon>
              <div>
                <!-- <strong>Summarization Process:</strong> -->
                The AI model will analyze the transcribed text and generate a concise summary based
                on the given prompt. 
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <div class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="SummarizedPreparePopup = false"
                  class="cancel-btn dialog-action-btn"
                >
                  <!-- <v-icon start size="18">mdi-close</v-icon> -->
                  Cancel
                </v-btn>

                <v-btn
                  id="button-summarized-uploadsoundtodocumentdetail"
                  variant="flat"
                  @click="SummarizedDetail()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!SummarizedRow.modelDisplayID"
                >
                  <v-img :src="images.uploadImg" alt="Upload" style="width: 20px; height: 20px;" class="mr-2" />
                  Generate Summary
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Chunk</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Are you sure you want to delete this Chunk ? This action cannot be undone.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-1"></v-img>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Loading bar-->>
    <v-overlay :value="loading">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import MultipleDragAndDrop from "@/components/MultipleDragAndDrop.vue";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";
import deleteIcon from "@/assets/images/trash-solid.svg";
import importImg from "@/assets/Icons/file-import.png";
import langImg from "@/assets/Icons/language.png";
import uploadImg from "@/assets/images/uploadwhite.png";
import importrightImg from "@/assets/images/file-import.png";
import saveImg from '@/assets/images/savecard.png';
export default {
  name: "UploadSoundToDocumentDetail",
  components: { MultipleDragAndDrop },
  computed: {
    documentId() {
      return this.$route.query.id || "";
    },
  },
  inject:[
    "FontColorTitle",
    "SubNavbarBackGround",
  ],
  data() {
    return {
      allowOptionWatch: false,
      uploadDialog: false,
      editDialog: false,
      itemsPerPage: 10,
      dataName: "",
      documentName: "",
      ShowAllText: false,
      CheckboxShowAllText: false,
      dialog_delete: false,
      deleteItem: null,
      today: null,
      searchDocName: "",
      langauge: ["TH", "EN"],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      Axios_ControllerAduio: null,
      loading: false,
      modelDisplayID: 0,
      DocId: 0,
      maxLimitedCharacter: 5000,
      importDocPopup: false,
      queryImport: 0,
      ImportData: "",
      listDDLVector: [],
      SummarizedPreparePopup: false,
      langaugeType: [
        { name: "TH", value: "th-TH" },
        { name: "EN", value: "en-US" },
      ],
      listDDModelDisplayName: [],
      modelDisplay: null,
      botSummation: false,
      images: {
        edit: editImg,
        delete: deleteImg,
        deleteIcon: deleteIcon,
        importImg: importImg,
        langImg: langImg,
        uploadImg: uploadImg,
        importrightImg: importrightImg,
        saveImg: saveImg
      },
      rules: {
        required: (value) => !!value || "Required.",
      },
      request: {
        dataName: "",
        filesList: [],
        langPop: "th-TH",
      },
      LangPop: "th-TH",
      speechDocumentDataDetail: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [],
      },
      speechDocumentData: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [],
      },
      edit: {
        id: 0,
        originalText: "",
        summarizedText: "",
      },
      SummarizedRow: {
        id: 0,
        originalText: null,
        summarizedText: null,
        modelDisplayID: 0,
      },
      headers: [
        {
          title: "No.",
          align: "center",
          value: "number",
          sortable: false,
          width: "10%",
        },
        {
          title: "Original Text",
          align: "start",
          value: "originalText",
          sortable: false,
          width: "40%",
        },
        {
          title: "Summarized Text",
          align: "center",
          value: "summarizedText",
          sortable: false,
          width: "40%",
        },
        { title: "Manage", align: "center", sortable: false, width: "10%" },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.allowOptionWatch) {
          this.GetSpeechDocumentDetail();
        }
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.speechDocumentDataDetail.data.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.speechDocumentDataDetail.data.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    incrementValue() {
      const currentValue = parseInt(this.maxLimitedCharacter) || 0;
      this.maxLimitedCharacter = currentValue + 1; // Increment by 100
    },
    
    decrementValue() {
      const currentValue = parseInt(this.maxLimitedCharacter) || 0;
      if (currentValue > 100) {
        this.maxLimitedCharacter = currentValue - 1; // Decrement by 100
      }
    },
    
    clearValue() {
      this.maxLimitedCharacter = '';
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; // January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Add() {
      this.uploadDialog = true;
    },
    processUpload(files) {
      let self = this;
      var validFiles = [];
      for (const file of files) {
        validFiles.push(file);
      }
      self.request.filesList = validFiles;
    },
    ImportDocument(item) {
      this.importDocPopup = true;
      this.ImportData =
        item.summarizedText == "-" ? item.originalText : item.summarizedText;
    },
    Save() {
      let self = this;
      if (!self.documentId) {
        alert("Please Fill All The Fields!");
        return;
      }

      if (!self.request.filesList || self.request.filesList.length === 0) {
        alert("Please Add some file!");
        return;
      }
      let formData = new FormData();
      self.request.dataName = self.documentId;
      self.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: self.Axios_ControllerAduio.signal,
      };

      self.request.filesList.forEach((file) => {
        formData.append(`FileSpeech`, file);
      });

      formData.append("LangPop", self.request.langPop);
      formData.append("dataName", self.request.dataName);
      formData.append("FileSpeech", self.request.filesList);
      if (self.modelDisplayID != 0 && self.botSummation == true) {
        formData.append("modelDisplay", self.modelDisplayID);
      }
      self.loading = true;
      try {
        self.$call.UploadSpeechDocument(
          formData,
          Config,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + dataResponse.message + " Updated!";
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: false,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.loading = false;
              self.uploadDialog = false;
              self.GetSpeechDocumentTable();
              self.GetSpeechDocumentDetail();
            }
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        self.LogTrace(error, "Save");
      }
    },
    SaveImport() {
      let self = this;
      let temp = {
        vectordbName: self.DocId,
        modelType: 1,
        groupReplaceID: null,
        Content: self.ImportData,
        flagNew: false,
        customCharacter: null,
        DetectLanguage: true,
        MaxLimitedCharacter: self.maxLimitedCharacter,
      };
      self.dialog = true;
      try {
        self.$call.SaveAddVector(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: false,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              self.importDocPopup = false;
            }
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    GetSpeechDocumentDetail() {
      let self = this;
      self.loading = true;
      if (self.isSearch) {
        self.options.page = 1;
        self.options.itemsPerPage = 10;
      }

      let { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy == undefined || self.options.sortBy.length == 0
          ? null
          : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc == undefined || self.options.sortDesc.length == 0
          ? null
          : self.options.sortDesc[0];

      var tempData = {
        page: page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        id: self.documentId,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocumentDetail(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentDataDetail.data = dataResponse.data.data;
            self.documentName = dataResponse.data.documentName;
            if (self.speechDocumentDataDetail.data != 0) {
              self.speechDocumentDataDetail.total = dataResponse.data.total;
              self.speechDocumentDataDetail.data.forEach((item) => {
                item.summarizedText =
                  item.summarizedText == null || item.summarizedText == ""
                    ? "-"
                    : item.summarizedText;
                item.show = self.ShowAllText;
              });
              self.AutoRefresh();
            }
            self.loading = false;
          }
        },
        (errorResource) => {
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    GetSpeechDocumentTable() {
      let self = this;
      const { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
      var tempData = {
        page: page,
        perPage: itemsPerPage,
        documentName: self.searchDocName,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocument(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentData.data = dataResponse.data.data;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    RefreshSpeechDocumentDetail() {
      let self = this;
      const { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
      var tempData = {
        page: page,
        perPage: itemsPerPage,
        id: self.documentId,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocumentDetail(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentDataDetail.data = dataResponse.data.data;
            if (self.speechDocumentDataDetail.data != 0) {
              self.speechDocumentDataDetail.total = dataResponse.data.total;
              self.speechDocumentDataDetail.data.forEach((item) => {
                item.summarizedText =
                  item.summarizedText == null ? "-" : item.summarizedText;
              });
            }
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    EditSpeechDocumentDetail(item) {
      let self = this;
      self.editDialog = true;
      self.edit = {
        id: item.id,
        originalText: item.originalText,
        summarizedText:
          item.summarizedText === "-" || item.summarizedText === " "
            ? null
            : item.summarizedText,
      };
    },
    EditSave() {
      let self = this;
      self.editDialog = false;
      // self.speechDocumentDataDetail.data.forEach((item) =>{
      //   if(item.id == self.edit.id){
      //     item.originalText = self.edit.originalText;
      //     item.summarizedText = self.edit.summarizedText ?? item.summarizedText;
      //   }
      // });
      self.$call.EditSpeechDocumentDetail(
        self.edit,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + dataResponse.message;
            self.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              backdrop: false,
              customClass: {
                popup: 'success-banner',
                title: 'success-banner-title'
              },
            });
          }
          self.GetSpeechDocumentDetail();
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    SummarizedPopup(item) {
      let self = this;
      self.SummarizedPreparePopup = true;
      self.SummarizedRow = {
        id: item.id,
        originalText: item.originalText,
        summarizedText: item.summarizedText,
        modelDisplayID: item.modelDisplayID,
      };
    },
    SummarizedDetail() {
      let self = this;
      self.loading = true;
      self.$call.SummarizedSpeechDocumentDetail(
        self.SummarizedRow,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " + dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                backdrop: false,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
          }
          self.loading = false;
          self.SummarizedPreparePopup = false;
          self.GetSpeechDocumentDetail();
        },
        (errorResource) => {
          self.loading = false;
          self.SummarizedPreparePopup = false;
          console.error(errorResource);
        }
      );
    },
    DeleteById(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete = true;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      var id = self.deleteItem
      try {
        self.dialog_delete = false;
        self.dialog = true;
        
        self.$call.DeleteSpeechDocumentDetail(
          id,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " + dataResponse.message;
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
                backdrop: false,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              if (
                self.speechDocumentDataDetail.data.length == 1 &&
                self.options.page != 1
              ) {
                self.options.page -= 1; //ถ้าลบข้อมูลสุดท้ายของหน้านั้นๆให้บังคับกลับไปหน้าก่อน
              }
              if (self.speechDocumentDataDetail.data.length == 1) {
                self.$router.push("/UploadSoundToDocument");
              }
              self.GetSpeechDocumentDetail();
            }
            self.loading = false;
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        self.dialog_delete = false;
        self.deleteItem = null;
      }
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    Search() {
      let self = this;
      self.GetSpeechDocumentDetail();
    },
    getStyle(template) {
      return template == "-" ? { textAlign: "center" } : { textAlign: "left" }; //make "-" placeholder center when it's was used
    },
    getItemModelNameText(item) {
      if (this.modelDisplayID == 0) {
        this.modelDisplayID = 1;
      }
      return `${item.modelDisplayID}: ${item.name}`;
    },
    getItemModelNameID(item) {
      return item.modelDisplayID;
    },
    GetDDLVector() {
      let self = this;
      self.$call.GetDDLVector(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDLVector = dataResponse.data;
          } else {
            self.listDDLVector = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    getDocName(item) {
      if (this.DocId == 0) this.DocId = item.id;
      return item.id;
    },
    getDocId(item) {
      return item.id;
    },
    formatText(text) {
      return text.replace(/ /g, "&nbsp;");
    },

    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        for (let doc of self.speechDocumentData.data) {
          if (doc.documentName == self.documentId) {
            if (doc.inProcess < doc.processFinish) {
              self.RefreshSpeechDocumentDetail();
              death_waiting = true;
              break;
            } else {
              death_waiting = false;
            }
          }
        }
        for (let doc of self.speechDocumentDataDetail.data) {
          if (doc.inProcess == true) {
            self.RefreshSpeechDocumentDetail();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != "/UploadSoundToDocumentDetail") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModelDisplayName = dataResponse.data;
          } else {
            self.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.maxLimitedCharacter = dataResponse.data;
          } else {
            self.maxLimitedCharacter = null;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
  },
  mounted() {
    this.GetDate();
    this.GetModel();
    this.GetDDLVector();
    this.GetMaxLimitedCharacter();
    this.GetSpeechDocumentDetail();
  },
};
</script>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 0 !important;
  border: 1px solid #DCDCDC;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.v-overlay--active {
  z-index: 2000 !important;
}

.v-data-table th,
.v-data-table td {
  white-space: normal !important;
  word-break: break-word;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.text-content-show {
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

.responsive-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
}

/* Header Section */
.header-section {
  background: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

/* Document Showcase */
.document-showcase {
  padding: 1.5rem;
  color: #171717;
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.document-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.document-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-info {
  flex: 1;
}

.document-label {
  font-size: 0.875rem;
  opacity: 0.9;
  font-weight: 500;
  display: block;
  margin-bottom: 0.25rem;
}

.document-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  word-break: break-word;
}

/* Controls Row */
.controls-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2rem;
  padding: 1.25rem 2rem;
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.toggle-section {
  display: flex;
  align-items: center;
}

.compact-toggle {
  background: #EDEDED;
  border-radius: 12px;
  padding: 0.25rem 0.75rem;
  border: 1px solid #e0e0e0a4;
  margin: 0;
  transform: scale(0.85);
}

.toggle-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 0.8rem;
  color: #424242;
}

.add-btn-green {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  height: 44px;
  min-width: 120px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  color: white !important;
}

.add-btn-green:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  background: linear-gradient(135deg, #66bb6a 0%, #4caf50 100%) !important;
}

.add-btn-green:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.add-btn-green:disabled {
  opacity: 0.6;
  transform: none !important;
  box-shadow: none !important;
  background: #e0e0e0 !important;
}

/* Table Row Styling */
.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Number Cell */
.number-cell {
  text-align: center;
  padding: 1rem 0.5rem;
  width: 80px;
}

/* Text Cells */
.text-cell {
  padding: 1rem;
  vertical-align: top;
  position: relative;
}

.text-container {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  min-height: 60px;
}

.text-content-wrapper {
  flex: 1;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
  line-height: 1.5;
  color: #424242;
  font-size: 0.875rem;
}

.text-content-show {
  white-space: normal;
  line-height: 1.6;
  color: #424242;
  font-size: 0.875rem;
}

/* Expand Button */
.expand-btn {
  background: transparent !important;
  border-radius: 12px !important;
  width: 32px !important;
  height: 32px !important;
  align-self: flex-start;
  margin-top: 0.5rem;
}

.expand-btn:hover {
  background: #FDE4DF !important;
  transform: scale(1.1);
}

/* Action Cell */
.action-cell {
  text-align: center;
  padding: 1rem 0.5rem;
  vertical-align: middle;
  width: 160px;
}

.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-group {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 4px 6px;
  transition: all 0.2s ease;
  gap: 8px;
}

/* .action-group:hover {
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
} */

.summarize-btn {
  border-radius: 10px !important;
  color: #e77b00 !important;
}

.summarize-btn:hover {
  background: #ff9800 !important;
  color: white !important;
}

/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}

/* .action-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
} */

/* Table Improvements */
:deep(.v-data-table-server) {
  border-radius: 0 0 16px 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table__wrapper) {
  border-radius: 0 0 16px 16px;
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table tbody tr:last-child td) {
  border-bottom: none;
}

/* Loading State */
:deep(.v-data-table--loading .v-data-table__wrapper) {
  opacity: 0.6;
}

/* Empty State */
:deep(.v-data-table-rows-no-data) {
  text-align: center;
  padding: 3rem;
  color: #757575;
  font-style: italic;
}

/* Custom Scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Dialog Styles - อิงจาก UploadSoundToDocument */
.upload-dialog,
.edit-dialog,
.import-dialog,
.summarize-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

/* .dialog-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 0;
} */

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  margin-right: 1rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgba(255, 255, 255, 0.3);
}

.header-text .dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: #171717;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
  color: #646464;
}

/* .close-btn {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
} */

/* Dialog Content */
.dialog-content {
  padding: 2rem;
}

.input-group {
  margin-bottom: 1rem;
}

.input-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  color: #424242;
  margin-bottom: 0.5rem;
}

.modern-input {
  background: white;
}
.modern-input :deep(.v-field) {
  border-radius: 16px;
  transition: all 0.2s ease;
}
.modern-input .v-field {
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-input.input-disabled {
  opacity: 0.6;
}

/* Inline Switch Styles */
.inline-switch {
  margin: 15px 0 0 0;
  padding: 0.5rem 1rem;
  background: #EDEDED;
  border-radius: 12px;
  border: 1px solid rgba(25, 118, 210, 0.1);
  width: 100%;
}
.inline-switch-active{
  background: #fff2fc;
  border-radius: 12px;
  width: 100%;
  margin: 15px 0 0 0;
  padding: 0.5rem 1rem;
}
/* Close All Button */
.close-all-btn {
  text-transform: none !important;
  font-weight: 500;
  border-radius: 10px !important;
  min-width: 120px;
  height: 40px;
  transition: all 0.2s ease;
  margin-bottom: 1em;
}

.close-all-btn:hover {
  background-color: #f4eeec !important;
}
.inline-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  color: #424242;
}

.inline-switch :deep(.v-switch__track),
.inline-switch :deep(.v-switch__thumb) {
  transform: scale(0.85);
}

/* Upload Section */
.upload-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.upload-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #424242;
}

.upload-area-card {
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  background: #fafafa;
}

.upload-area-card :deep(.v-card) {
  width: 100% !important;
  border: none !important;
}

.upload-area-card :deep(.v-card .v-card-text .v-icon) {
  color: rgba(0, 0, 0, 0.377) !important;
}

.upload-area-card.drag-over {
  border-color: #1976d2;
  background: rgba(25, 118, 210, 0.05);
  transform: scale(1.02);
}

.upload-help-text {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  font-size: 0.8rem;
  color: #757575;
}

/* Info Card */
.info-card {
  /* background: rgba(33, 150, 243, 0.05);
  border: 1px solid rgba(33, 150, 243, 0.2); */
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  font-size: 0.875rem;
  color: #424242;
}

/* Dialog Actions */
/* .dialog-actions {
  background: white;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e0e0e0;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.action-btn {
  border-radius: 10px !important;
  font-weight: 500;
  text-transform: none;
  height: 38px;
  width: 38px;
  transition: all 0.2s ease;
}

.delete-btn {
  height: 38px !important;
  width: 38px !important;
}
.cancel-btn {
  border-radius: 10px !important;
  border-color: #bdbdbd;
  color: #757575;
}

.cancel-btn:hover {
  background: rgba(189, 189, 189, 0.1);
  transform: scale(1.05);
} */
/* 
.upload-btn {
  border-radius: 10px; */
/* background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%); */
/* box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.upload-btn:hover {
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
  transform: translateY(-1px);
} */

.import-btn {
  border-radius: 10px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.import-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-1px);
}

.padding-btn {
  padding: 0 1.5rem;
}

/* Edit Dialog Specific */
.edit-dialog .header-icon-wrapper {
  background: rgba(255, 152, 0, 0.2);
}

.edit-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Import Dialog Specific */
.import-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Summarize Dialog Specific */
.summarize-icon {
  background: rgba(255, 255, 255, 0.2) !important;
}

/* Save Button */
/* .save-btn {
  border-radius: 10px;
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.save-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-1px);
} */

/* Summarize Button */
/* .summarize-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
} */

.summarize-btn:hover {
  box-shadow: 0 6px 16px rgba(255, 152, 0, 0.4);
  transform: translateY(-1px);
}

/* Modern Textarea */
.modern-input .v-textarea :deep(.v-field__field) {
  min-height: 120px;
}

/* Disabled Input Style */
.modern-input:has(.v-field--disabled) {
  opacity: 0.7;
}

/* Transitions */
.v-dialog-transition-enter-active,
.v-dialog-transition-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-dialog-transition-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.v-dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-start .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
.custombtn{
  min-width: 100px;
}
:deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #872612;
  opacity: 1!important;
}
.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border: 1px solid #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border:1px solid #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  width: 30px;
  height: 30px;
}
.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
:deep(.v-data-table-footer .v-field) {
  border-radius: 10px !important;
  width: 70px !important;
}
/* Responsive Design */
@media (max-width: 768px) {
  .document-showcase {
    padding: 1rem 1.5rem;
  }

  .document-header {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .document-name {
    font-size: 1.25rem;
  }

  .controls-row {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1.5rem;
  }

  .toggle-section {
    width: 100%;
    justify-content: center;
  }

  .add-btn-green {
    width: 100%;
    max-width: 200px;
  }

  .action-group {
    flex-direction: column;
    gap: 2px;
    padding: 6px 4px;
  }

  .action-divider {
    width: 80%;
    height: 1px;
    margin: 2px 0;
  }

  .action-btn {
    width: 32px !important;
    height: 32px !important;
  }

  .text-container {
    flex-direction: column;
    gap: 0.5rem;
  }

  .expand-btn {
    align-self: center;
    margin-top: 0;
  }

  .header-content {
    padding: 1rem;
  }

  .dialog-content {
    padding: 1rem;
  }

  .dialog-actions {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .actions-left,
  .actions-right {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .document-showcase {
    padding: 0.75rem 1rem;
  }

  .document-name {
    font-size: 1.1rem;
  }

  .controls-row {
    padding: 0.75rem 1rem;
  }

  .text-cell {
    padding: 0.5rem;
  }

  .text-content-wrapper {
    padding: 0.5rem;
  }

  .action-cell {
    padding: 0.5rem 0.25rem;
    width: 120px;
  }
}
.number-controls-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%;
}
.number-arrow-btn {
  width: 24px !important;
  height: 16px !important;
  min-width: unset !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  transition: all 0.15s ease !important;
}

.number-arrow-btn:hover {
  background: rgba(56, 89, 208, 0.1) !important;
}

.number-arrow-btn:active {
  background: rgba(56, 89, 208, 0.2) !important;
  transform: scale(0.95);
}
.clear-btn-custom {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  background: #A6A6A6 !important;
  color: white !important;
  transition: all 0.2s ease !important;
}

.clear-btn-custom:hover {
  background: rgba(102, 102, 102, 0.2) !important;
}
.number-arrows{
  margin-bottom: 10px;
}
</style>
